export default __webpack_public_path__ + "static/media/regulatory--end-of-trucks-and-buses-only--g1.8a6ab26d.png";